import { render } from "./ActionsPanel.vue?vue&type=template&id=673632ec&scoped=true&lang=pug"
import script from "./ActionsPanel.vue?vue&type=script&lang=js"
export * from "./ActionsPanel.vue?vue&type=script&lang=js"

import "./ActionsPanel.vue?vue&type=style&index=0&id=673632ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673632ec"]])

export default __exports__